import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Recipient } from '../../../types';
import { ConstructPatch } from '../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const saveRecipient = (
  constructPatch: ConstructPatch,
  data: Record<string, any>,
): Promise<NonPaginatedResponse<Recipient> | undefined> =>
  constructPatch<NonPaginatedResponse<Recipient>>(
    `${SIGNATURE_BASE_PATH}/recipient`,
    { data },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
